import React, { useState, useEffect } from 'react';
import { InputField } from 'components/Form';
import { Spinner, Text } from 'components/Elements';
import { useBaseRate } from '../api/getBaseRate';
import storage from 'utils/storage';

export const FancyRateContainer = ({
  formData,
  loadingRate,
  handleRealRateChange,
  handleChargeChange,
  handleUserRateChange,
}) => {
  const conversionQuery = useBaseRate({
    baseCurrency: formData.baseCurrency?.id,
    quoteCurrency: formData.quoteCurrency?.id,
  });

  // Update realRate when API data changes
  const [realRate, setRealRate] = useState(formData.realRate);

  useEffect(() => {
    if (conversionQuery.data?.rate?.rate) {
      storage.setTempData({
        swapRateId: conversionQuery.data.rate.id,
      });
      setRealRate(conversionQuery.data.rate.rate);

      handleRealRateChange({ target: { value: conversionQuery.data.rate.rate } });
    }
  }, [conversionQuery.data?.rate?.rate]);

  if (conversionQuery.isLoading) {
    return (
      <div className="w-full h-48 flex justify-center items-center">
        <Spinner size="sm" />
      </div>
    );
  }

  return (
    <div className="p-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg">
      <div className="bg-white/10 rounded-lg p-4 shadow-md">
        <div className="flex flex-row items-end space-x-3">
          <div className="mb-3">
            {!conversionQuery.data && <>Unable to retrieve real rate</>}
            <InputField
              label="Real Rate"
              value={realRate}
              onChange={(e) => {
                setRealRate(e.target.value);
                handleRealRateChange(e);
              }}
              type="number"
            />
          </div>
          <div className="mb-3">
            <InputField
              label="Charge"
              value={formData.charge}
              onChange={handleChargeChange}
              type="number"
              endIcon="%"
            />
          </div>
          <div className="mb-3">
            <InputField
              label="User Rate"
              value={formData.userRate}
              onChange={handleUserRateChange}
              type="number"
            />
          </div>
        </div>
        {loadingRate && (
          <Text variant="caption" className="animate-pulse text-gray-600">
            Fetching real rate...
          </Text>
        )}
      </div>
      <div className="flex flex-col sm:flex-row justify-between items-center mt-2 px-2">
        <div className="flex items-center space-x-1">
          <span className="w-2 h-2 bg-green-500 rounded-full animate-ping"></span>
          <span className="text-xs font-medium text-white/60">Live Rates</span>
        </div>
        <div className="text-xs text-gray-100">
          Data Source: <span className="font-semibold">Wire24Rates-API</span>
        </div>
      </div>
    </div>
  );
};
